var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 12.4997L12.5002 9.99967M12.5002 9.99967L10.0002 7.49967M12.5002 9.99967L3.3335 9.99968M7.50016 14.1663C7.50016 14.9429 7.50016 15.3312 7.62703 15.6375C7.79619 16.0459 8.12043 16.3703 8.52881 16.5395C8.83509 16.6664 9.2236 16.6663 10.0002 16.6663H14.0002C14.9336 16.6663 15.4001 16.6663 15.7567 16.4847C16.0703 16.3249 16.3256 16.07 16.4854 15.7564C16.667 15.3998 16.6668 14.9331 16.6668 13.9996V5.99963C16.6668 5.06621 16.667 4.59956 16.4854 4.24304C16.3256 3.92944 16.0703 3.67445 15.7567 3.51466C15.4001 3.33301 14.9336 3.33301 14.0002 3.33301H10.0002C9.22359 3.33301 8.83509 3.33301 8.52881 3.45988C8.12043 3.62903 7.79619 3.95348 7.62703 4.36186C7.50016 4.66814 7.50016 5.05643 7.50016 5.833",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.652f4f9ae94c16952b63ea7b39691510.svg";
export { ForwardRef as ReactComponent };